var DEFAULT_HOOKS = ['activate', 'mount', 'update'];
export { DEFAULT_HOOKS };